import { render, staticRenderFns } from "./LanguageSelect.vue?vue&type=template&id=c1689244&scoped=true"
import script from "./LanguageSelect.vue?vue&type=script&lang=js"
export * from "./LanguageSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1689244",
  null
  
)

export default component.exports